import { BaseQueryApi, BaseQueryFn, createApi, FetchArgs, fetchBaseQuery, FetchBaseQueryError, skipToken } from '@reduxjs/toolkit/query/react'
//import { getAuthToken } from "../app/authiutils"
import { profileApi } from './profilesSlice'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { authService } from '../app/authService';
import { createHandleQueryErrorAndRetry } from '../app/rtkQueryErrorHandler';
import { AppDispatch, RootState } from '../app/store';
import { ChatService } from './chatService'
import { checkAndRefreshAccessToken, clearSessionRTK, selectAuthMethod, selectIsAuthenticated, selectIsAuthReady, selectSessionRTK, selectStateRTK, setAuthenticated } from './userTokenManagementSlice';
import { oidcApi } from './oidcSlice';
import { RawMessage } from './chatSelectors';
import { printError } from '../app/utils';
import { CUSTOM_METHOD, storage } from '../app/auth/utils';
//import { authService } from '../app/awsAuthService'


export function getValuesByKeyString(obj: { [key: string]: any }, searchString: string): any[] {
    const result: any[] = [];

    // Iterate through object keys
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            // Check if key contains the search string
            if (key.includes(searchString)) {
                result.push(obj[key]);
            }
        }
    }
    return result;
}

export interface UserAndChat {//extends ChatUser {
    chatId: number
    //type: string
    id: number
    userName: string


}
export interface ChatUser {
    //iamId: string,
    id: number,
    userName?: string
}
export interface DirectChatUsers extends ChatUser {
    messageToId?: number
    sendInChat?: boolean
    sendEmail?: any
    message?: string
    messageChat?: string,
    messageEmail?: string,
    subject?: string,
    chatName?: string,
    metadata?: any,
    chatMetadata?: any,
    messageContent?: string
}
// const GetMatchedQueryData: (api: any, toMatch: string) => any = (api, sub) => {
//     const matchingSubQuerries = getValuesByKeyString(api.queries, sub)
//     if (matchingSubQuerries.length === 0)
//         return undefined
//     if (matchingSubQuerries[0].status === 'fulfilled') {
//         return matchingSubQuerries[0].data
//     }
//     return undefined
// }
interface BaseQueryApiWithAppDispatch {
    dispatch: AppDispatch;
    getState: () => RootState;
    // ... other properties from BaseQueryApi if needed ...
}
// 1. Define the original BaseQuery to correctly resolve to a function
// see qryFuncWithSubHeader below

// 2. Define a type alias for the original base query function's signature
// This tells TypeScript that 'originalBaseQuery' is a function that returns a Promise.
type OriginalBaseQuery = BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, {}>;
// Define the inner base query function type (to correctly await)
type InnerBaseQuery = BaseQueryFn<string | FetchArgs, any, FetchBaseQueryError, {}, any>;
//baseQueryWithReauth
export const baseQueryWithReauth: BaseQueryFn<
    string | FetchArgs,  // 1. Args (Type of the first parameter to baseQuery)
    any,             // 2. Result (Type of the successful data result)
    FetchBaseQueryError, // 3. Error (Type of the error object)
    {},                  // 4. DefinitionExtraOptions (Use {} if none)
    any // { dispatch: AppDispatch; getState: () => RootState } // 5. Meta/API (Use a custom type to define dispatch/getState)
> = async (args, api, extraOptions) => {
    const { dispatch } = api as unknown as BaseQueryApiWithAppDispatch;
    //test
    // TESTING checkAndRefreshAccessToken that's why true
    // try {
    //     const refreshResultTest = await api.dispatch(checkAndRefreshAccessToken(true)).unwrap();
    // } catch (error) {
    //     console.error(error)
    // }


    // Cast the original baseQuery function to ensure its return value is seen as a Promise
    const baseQuery = qryFuncWithSubHeader as unknown as InnerBaseQuery;
    // 1. Initial request
    let result = await baseQuery(args, api, extraOptions);

    // 2. Check for 401 error
    if (result.error && result.error.status === 401) {
        console.log('401 detected. Attempting token renewal...');

        // 3. Dispatch the Thunk using the available api.dispatch
        const state = api.getState() as RootState;
        const authMethod = selectAuthMethod(state);
        if (authMethod === CUSTOM_METHOD) {
            try {
                // check if auth method is custom before renewing sms          
                const refreshResult = await api.dispatch(oidcApi.endpoints.renewSms.initiate('reauth')).unwrap();;
                if (refreshResult && !refreshResult.error) {
                    console.log('Renewal successful. Retrying original query...');
                    // 4. Renewal succeeded: Retry the original query
                    result = await baseQuery(args, api, extraOptions);
                } else {
                    // 5. Renewal failed: Dispatch clear session and/or navigate to login
                    console.error('Renewal failed. Need to log user out.');
                    // You might dispatch a global logout action here if you had one:
                    const refreshResult = await api.dispatch(oidcApi.endpoints.logoutSMS.initiate()).unwrap();
                }

            } catch (error) {
                console.error(`${printError(error)}. Need to log user out.`);
                storage.clearSession();
                dispatch(clearSessionRTK());
                dispatch(setAuthenticated(false));
                const refreshResult = await api.dispatch(oidcApi.endpoints.logoutSMS.initiate()).unwrap();
            }
        }

    }
    return result;
};


// 1. Define the original BaseQuery to correctly resolve to a function
export const qryFuncWithSubHeader = fetchBaseQuery(
    {
        prepareHeaders: async (headers, api) => {
            const { getState } = api;
            // 2. the state is updated in the wrapper baseQueryWithReauth on this functions 401 fail so its up-to-date
            const state: RootState = getState() as RootState;

            const session = selectSessionRTK(state)
            //const tokenPayload = state.userTokenManagement.tokenPayload;
            const isAuthenticated = selectIsAuthenticated(state)
            const issAuthReady = selectIsAuthReady(state)
            //const currentAccessToken = state.userTokenManagement.tokenPayload?.access_token// refreshedAccessToken;
            //not checking getLoggedInUserProfileStatus but check if have the actual profile data
            //if (!authError && isAuthenticated && getLoggedInUserProfileStatus === "fulfilled" && lastQueryKey) {
            const lastQueryKey = Object.keys(state.profileApi?.queries).filter((key) => key.startsWith('getLoggedInUserProfile')).pop();
            const loggedinProfileQuery = lastQueryKey ? state.profileApi?.queries[lastQueryKey] : undefined

            if (session && isAuthenticated) {
                const sub = session.sub // authService.getUserSub();
                if (sub) headers.set('sub', sub!);
                if (session.access_token) { // if access_token is in session pass it otherwise it must be in an http cookie
                    const token = session.access_token//authService.getAccessToken();            
                    headers.set('Authorization', `Bearer ${token!}`);
                }
                //const loggedinProfileQuery = state.profileApi?.queries[lastQueryKey];
                const loggedinProfile = loggedinProfileQuery?.data as any;
                const loggedinProfileId = loggedinProfile?.id;
                const loggedinProfileError = loggedinProfileQuery?.error;
                if (!loggedinProfileError && loggedinProfileId) {
                    headers.set('id', loggedinProfileId)//.toString());
                }

            } else {
                // If not fully authenticated, if there's a profile error, or if loggedinProfileId is missing/361:
                headers.set('sub', 'unauthenticated');
                headers.delete('Authorization');
                headers.delete('id');
            }

            return headers;
        },
        // fetchFn: async (input, init) => {
        //     const customInit = {
        //         ...init,
        //         credentials: 'omit' as RequestCredentials,
        //     };
        //     return fetch(input, customInit);
        // },
        // credentials: "include"
    });

export const objectToQueryString = (params: Record<string, unknown>): string => {
    return new URLSearchParams(
        Object.fromEntries(
            Object.entries(params)
                .filter(([_, value]) => value !== undefined) // Remove undefined values
                .map(([key, value]) => [key, String(value)]) // Convert all values to strings
        )
    ).toString();
};


export const chatApi = createApi({
    reducerPath: 'chatApi',
    baseQuery: baseQueryWithReauth, //qryFuncWithSubHeader,
    tagTypes: ['CHAT', 'Ready', 'ChatUsers', 'MessageCount', 'AnalyticsGroupChat', 'UpdateChatURL'],
    endpoints: (builder) => ({
        //gest profile  by iam_is inserts if no matching profile found        
        getChatUser: builder.query<any, DirectChatUsers | typeof skipToken>({
            query: (directChatUsers) => {
                if (directChatUsers === skipToken)
                    return ""
                const encodedUserName = encodeURIComponent(directChatUsers.userName ?? '');
                const url = `/api/chat/?username=${encodedUserName}&id=${directChatUsers.id}${directChatUsers.messageToId ? `&messageTo=${directChatUsers.messageToId}` : ""}`
                return url
            },
            providesTags: (result, response, arg) => {
                //return [{ type: 'CHAT' as const, id: arg === skipToken? undefined: arg.iamId }]
                return ['CHAT']
            }
        }),
        // getMessaging: builder.query<any, number>({
        //     query: (id) => ({
        //         url: `/api/chat/Messaging/?id=${id}`,
        //         method: 'GET',
        //     }),
        //     onQueryStarted: (arg, api) => {
        //         // Create the handler instance with RootState (inferred at this point)
        //         const handler = createHandleQueryErrorAndRetry<RootState>(
        //             'getMessaging',
        //             chatApi.endpoints.getMessaging.initiate // <--- Pass the specific initiate function here!
        //         );
        //         // Execute the handler
        //         handler(arg, api);
        //         console.log('getLoggedInUserProfile query started with args:', arg);
        //     },
        //     providesTags: (result, response, updated) => {
        //         return ['Ready']//{ type: 'Ready', id: updated }]
        //     }
        // }),
        // getMessageCount: builder.query<any, number>({
        //     query: (id) => ({
        //         url: `/api/chat/MessageCount/?id=${id}`,
        //         method: 'GET',
        //     }),
        //     providesTags: (result, response, updated) => {
        //         return [{ type: 'MessageCount' }]
        //     }
        // }),
        setChatUser: builder.mutation<RawMessage, DirectChatUsers>({
            query: (directChatUsers) => {
                const { sendEmail, subject, messageEmail, messageToId, id, ...params } = directChatUsers
                const sendEmailObj = sendEmail ? (typeof directChatUsers.sendEmail === 'object' ? sendEmail : { message: sendEmail }) : null
                if (subject) {
                    sendEmailObj.subject = directChatUsers.subject
                }
                if (messageEmail) {
                    sendEmailObj.message = directChatUsers.messageEmail
                }
                const queryString = objectToQueryString(params);
                //const sentInChatParms = `${directChatUsers.sendInChat ? `&sendInChat=${directChatUsers.sendInChat}${directChatUsers.messageChat ? `&messageChat=${encodeURIComponent(directChatUsers.messageChat)}` : ''}${directChatUsers.message ? `&message=${directChatUsers.message}` : ''}` : ''}`
                return {
                    url: `/api/chat/?${queryString}`,//${sentInChatParms ? `?${sentInChatParms}` : ''}`,
                    method: 'PUT',
                    body: {
                        ids: [directChatUsers.id, ...directChatUsers.messageToId || directChatUsers.messageToId === 0 ? [directChatUsers.messageToId] : []],
                        ...directChatUsers.chatName ? { chatName: directChatUsers.chatName } : {},
                        ...directChatUsers.metadata ? { metadata: directChatUsers.metadata } : {},
                        ...directChatUsers.chatMetadata ? { chatMetadata: directChatUsers.chatMetadata } : {},
                        ...directChatUsers.messageContent ? { messageContent: directChatUsers.messageContent } : {},
                        ...sendEmailObj ? { sendEmail: sendEmailObj } : {}
                    },
                }
            },
            invalidatesTags: (result, response, idsArg) => ['Ready']
        }),
        setNamedChatManyUsers: builder.mutation<any, { chatName: string, ids: number[] }>({
            query: ({ chatName, ids }) => ({
                url: `/api/chat/?chatName=${chatName}`,
                method: 'PUT',
                body: ids,//directChatUsers,
            }),
            invalidatesTags: (result, response, idsArg) => ['Ready']
        }),
        createOrJoinAnalyticsGroupChat: builder.mutation<any, { analyticsProfileId: number, initiatorId: number, ids: number[], col: string, value: string }>({
            query: ({ analyticsProfileId, initiatorId, ids, col, value }) => {  //using header for authorization
                const encodedValue = encodeURIComponent(value ?? '');
                return {
                    url: `/api/chat/createOrJoinAnalyticsGroupChat/?analyticsProfileId=${analyticsProfileId}&initiatorId=${initiatorId}&col=${col}&value=${encodedValue}`,
                    method: 'PUT',
                    body: ids,// initiator id must be ids[0]
                }
            },
            invalidatesTags: (result, response, idsArg) => ['Ready']//'MessageCount',
        }),
        createOrJoinGroupChat: builder.mutation<any, { loggedInId: number, ids: number[], channelName: string, channelType: string }>({
            query: ({ loggedInId, ids, channelName, channelType }) => {
                const encodedValue = encodeURIComponent(channelName ?? '');
                return {
                    url: `/api/chat/createOrJoinGroupChat/?channelName=${encodedValue}&channelType=${channelType}`,
                    method: 'PUT',
                    body: ids,//
                }
            },
            invalidatesTags: (result, response, idsArg) => ['Ready']//'MessageCount',
        }),

        createOrJoinOpenChat: builder.mutation<any, { ids: number[], channelUrl: string, channelName: string, channelType: string }>({
            query: ({ ids, channelUrl, channelName, channelType }) => {
                const encodedValue = encodeURIComponent(channelName ?? '');
                return {
                    url: `/api/chat/createOrJoinAnalyticsOpenChat/?channelName=${encodedValue}&channelUrl=${channelUrl}${channelType ? `&channelType=${channelType}` : ''}`,
                    method: 'PUT',
                    body: ids,//
                }
            },
            invalidatesTags: (result, response, idsArg) => ['Ready']//'MessageCount',
        }),

        // patchChatUser: builder.mutation<any, { iamId: string, type: string, stepsCompleted: number, surveyDTO: any }>({
        //     query: ({ iamId, type, stepsCompleted, surveyDTO: survey2Update }) => ({
        //         url: `/api/surveys?iamId=${iamId}&type=${type}&stepsCompleted=${stepsCompleted}`,
        //         method: 'PATCH',
        //         body: survey2Update,
        //     }),
        //     invalidatesTags: (result, response, updated) => [{
        //         type: 'Chat',
        //         id: updated.iamId
        //     }]
        // }),

        // updateChatUser: builder.mutation<any, { iamId: string, type: string, surveyDTO: any }>({
        //     query: ({ iamId, type, surveyDTO: survey2Update }) => ({
        //         url: `/api/surveys?iamId=${iamId}&type=${type}`,
        //         method: 'PUT',
        //         body: survey2Update,
        //     }),
        //     invalidatesTags: (result, response, updated) => [{
        //         type: 'Chat',
        //         id: updated.iamId
        //     }]
        // }),

        deleteChat: builder.mutation<void, UserAndChat>({
            query: (arg) => {
                //console.log('Deleting chat', arg)
                return ({
                    url: `/api/chat/?chatId=${arg.chatId}&id=${arg.id}&name=${arg.userName}`,
                    method: 'DELETE',
                })
            },
            //invalidatesTags: (result, response, updated) => [{ type: 'Profile', id: updated }]
        }),

        // deleteUser: builder.mutation<void, number>({
        //     query: (id) => {
        //         //console.log('Deleting chat', arg)
        //         return ({
        //             url: `/api/chat/deleteuser/?id=${id}`,
        //             method: 'DELETE',
        //         })
        //     },
        //     //invalidatesTags: (result, response, updated) => [{ type: 'Profile', id: updated }]
        //}),
    }),
})


// interface UserState { count: number }
// const initialState: UserState = { count: 0 };
// export const chatCount = createSlice({
//     name: 'chatCount',
//     initialState,
//     reducers: {
//         setChatCount(state, action: PayloadAction<number>) {
//             state.count = action.payload;
//         },
//     },
// });
// export const { setChatCount } = chatCount.actions;
// export default chatCount.reducer;


export const { /*useGetMessagingQuery, useGetMessageCountQuery,*/ useSetChatUserMutation, useSetNamedChatManyUsersMutation, useGetChatUserQuery, useDeleteChatMutation, useCreateOrJoinAnalyticsGroupChatMutation, useCreateOrJoinGroupChatMutation, useCreateOrJoinOpenChatMutation } = chatApi




